"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const framer_motion_1 = require("framer-motion");
const ArrowLeft_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft"));
const ArrowRight_1 = __importDefault(require("@kyruus/react-ikons/ArrowRight"));
const MiniProviderPageList_styles_1 = require("./MiniProviderPageList.styles");
const CARD_TRANSITION = 250;
const variants = {
    enter: (direction) => ({
        x: direction > 0 ? CARD_TRANSITION : -CARD_TRANSITION,
        opacity: 0
    }),
    center: {
        zIndex: 1,
        x: 0,
        opacity: 1
    },
    exit: (direction) => ({
        zIndex: 0,
        x: direction < 0 ? CARD_TRANSITION : -CARD_TRANSITION,
        opacity: 0
    })
};
/**
 * Determine a valid swipe based on swipe velocity & distance
 */
const SWIPE_CONFIDENCE_THRESHOLD = 10000;
const swipePower = (offset, velocity) => Math.abs(offset) * velocity;
/**
 * A component for rendering a page list around passed in child provider cards.
 */
const MiniProviderPageList = ({ children, headerMessage }) => {
    // State for currently shown provider index
    const [[page, direction], setPage] = (0, react_1.useState)([0, 0]);
    const canPageLeft = page > 0;
    const canPageRight = page < react_1.default.Children.count(children) - 1;
    const handlePaginate = (newDirection) => {
        setPage([page + newDirection, newDirection]);
    };
    const handleDragEnd = (_event, { offset, velocity }) => {
        const power = swipePower(offset.x, velocity.x);
        // paginated left or right based on drag location
        if (canPageLeft && power > SWIPE_CONFIDENCE_THRESHOLD) {
            handlePaginate(-1);
        }
        else if (canPageRight && power < -SWIPE_CONFIDENCE_THRESHOLD) {
            handlePaginate(1);
        }
    };
    return (react_1.default.createElement("div", { role: "region", "aria-labelledby": "mini-provider-page-header" },
        react_1.default.createElement(MiniProviderPageList_styles_1.PageListControls, { "data-testid": "mini-provider-page-controls" },
            react_1.default.createElement(MiniProviderPageList_styles_1.PageListHeading, { id: "mini-provider-page-header" },
                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, headerMessage))),
            react_1.default.createElement(MiniProviderPageList_styles_1.PageListPaging, { "aria-controls": "mini-provider-page" },
                react_1.default.createElement(MiniProviderPageList_styles_1.PageListLeft, { active: true, disabled: canPageLeft === false, icon: react_1.default.createElement(ArrowLeft_1.default, { size: "12px" }), mode: "flat", onClick: () => handlePaginate(-1), "data-testid": "MiniProviderPage-left", "aria-hidden": canPageLeft === false }),
                react_1.default.createElement(MiniProviderPageList_styles_1.PageListPageNumber, null,
                    page + 1,
                    "/",
                    react_1.default.Children.count(children)),
                react_1.default.createElement(MiniProviderPageList_styles_1.PageListRight, { active: true, disabled: canPageRight === false, icon: react_1.default.createElement(ArrowRight_1.default, { size: "12px" }), mode: "flat", onClick: () => handlePaginate(1), "data-testid": "MiniProviderPage-right", "aria-hidden": canPageRight === false }))),
        react_1.default.createElement(framer_motion_1.AnimatePresence, { custom: direction, exitBeforeEnter: true, initial: false },
            react_1.default.createElement(framer_motion_1.motion.div, { id: "mini-provider-page", key: page, custom: direction, drag: "x", dragDirectionLock: true, dragElastic: 1, dragConstraints: { left: 0, right: 0 }, onDragEnd: handleDragEnd, initial: "enter", animate: "center", exit: "exit", variants: variants, transition: {
                    x: { type: 'spring', stiffness: 250, damping: 20 }
                } }, react_1.default.Children.toArray(children)[page]))));
};
exports.default = MiniProviderPageList;
//# sourceMappingURL=MiniProviderPageList.js.map